import { createPublicClient, createWalletClient, http, custom, fallback } from 'viem';
import { xLayer } from './wagmi';
import { X_LAYER_RPC_URLS } from '@/config/constants/rpc';

// 创建备选RPC传输层
const createFallbackTransport = () => {
  const transports = X_LAYER_RPC_URLS.map(url => http(url));
  return fallback(transports);
};

// 创建 viem 公共客户端
export const createViemPublicClient = () => {
  return createPublicClient({
    chain: xLayer,
    transport: createFallbackTransport()
  });
};

// 创建 viem 钱包客户端
export const createViemWalletClient = (account: `0x${string}`) => {
  if (typeof window !== 'undefined' && window.ethereum) {
    return createWalletClient({
      account,
      chain: xLayer,
      transport: custom(window.ethereum)
    });
  }
  return null;
};

// 预创建的公共客户端实例（单例模式）
export const publicClient = createPublicClient({
  chain: xLayer,
  transport: createFallbackTransport()
});
